/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import React from 'react';
import { IHosportsCareersListViewProps } from './../../../modules/hosports-careers-list/./hosports-careers-list';
// @ts-ignore
import {GetCareers} from './../utilities/dataFunctions';

interface IState {
  careers?:any;
}

/**
 *
 * HosportsSupportPage component
 * @extends {React.PureComponentReact.Component<IHosportsTvPageViewProps>}
 */

class HosportsCareersList extends React.Component<IHosportsCareersListViewProps,IState> {

  public state: IState;

  constructor (props: IHosportsCareersListViewProps) {
      super(props);
      this.state = {
        careers : []
      };
  }

  public componentDidMount = async() => {
    let config:any = this.props.config;
    if(config){
      if(config.brand){
        let careers = await GetCareers(config.brand);
        this.setState({
          careers:careers
        })
      }
    }
  }

  public render(): JSX.Element {
    return (
      <div className={'hosports-careers-list'}>
        <div className="medium-padding light-grey-background">
          <div className="small-padding centered-text full-width"><h3>{'Open Positions'}</h3></div>
          <div className="max-width-container white-background shadow">
            {this.state.careers && this.state.careers.map((value:any)=>{
              return(
                <div className="small-padding">
                  {value.attributes.title &&
                    <div className="tiny-padding" style={{paddingTop:0}}>
                      <h4><b>{value.attributes.title}</b></h4>
                    </div>
                  }
                  <div className="tiny-padding" style={{paddingTop:0}}>
                    <h6 className="subheading">
                      {value.attributes.level && <span>{value.attributes.level}</span>}
                      {' | '}
                      {value.attributes.type && <span>{value.attributes.type}</span>}
                      {' | '}
                      {value.attributes.location && <span>{value.attributes.location}</span>}
                    </h6>
                  </div>
                  <div className="tiny-padding">
                    <a className="button black-background white" href={"./career?id="+value.id}>{'View Job'}</a>
                  </div>
                </div>
              )
            })}
          </div>
        </div>
      </div>
    );
  }
}

export default HosportsCareersList;
